<script lang="ts" setup>
import { compile } from "path-to-regexp"
import { ref, watch } from "vue"
import { type RouteLocationMatched, useRoute, useRouter } from "vue-router"

const route = useRoute()
const router = useRouter()

const breadcrumbs = ref<RouteLocationMatched[]>([])

const getBreadcrumb = () => {
  const matched = route.matched.filter((item) => {
    return item.meta && item.meta.title && item.meta.breadcrumb !== false
  })
  // 相邻同名段只保留最后一条:总部多级路由(菜单/组/tab)同名时面包屑会连显(如 首页/首页/首页)
  breadcrumbs.value = matched.filter((item, index) =>
    index === matched.length - 1 || item.meta.title !== matched[index + 1].meta.title,
  )
}

const pathCompile = (path: string) => {
  const { params } = route
  const toPath = compile(path)
  return toPath(params)
}

const handleLink = (item: RouteLocationMatched) => {
  const { redirect, path } = item
  if (redirect) {
    router.push(redirect as string)
    return
  }
  router.push(pathCompile(path))
}

watch(
  () => route.path,
  (path) => {
    if (path.startsWith("/redirect/")) {
      return
    }
    getBreadcrumb()
  },
)

getBreadcrumb()
</script>

<template>
  <el-breadcrumb class="app-breadcrumb">
    <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="item.path">
      <span v-if="item.redirect === 'noRedirect' || index === breadcrumbs.length - 1" class="no-redirect whitespace-nowrap">
        {{ item.meta.title }}
      </span>
      <a v-else @click.prevent="handleLink(item)" class="whitespace-nowrap">
        {{ item.meta.title }}
      </a>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<style lang="scss" scoped>
.el-breadcrumb__inner,
.el-breadcrumb__inner a {
  font-weight: 400 !important;
  color: var(--bussiness-container-breadcrumb-color) !important;
}

.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  margin-left: 8px;
  overflow: hidden;
  font-size: 14px;
  line-height: var(--v3-navigationbar-height);

  .no-redirect {
    color: var(--bussiness-container-breadcrumb-color);
    cursor: text;
  }
}
</style>
